import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
// Components
import App from '../../../components/app';
import EnhancedTable from '../../../components/table';
// Modules
import { tableRequestPoints } from '../../../redux/reducers/table';
// Ressources
import DateUtils from '../../../utils/dateUtils';
import FormattingUtils from '../../../utils/formattingUtils';
import { AccountRight } from '../../../utils/userUtils';
import { generateOptionsString } from '../../../utils/businessUtils';
import { Cell, createCell } from '../../../components/table/table-cell-creator';
import { FormatType, HeadCell, PickerOption } from '../../../local-types';

interface PartnerBillsListProps extends WithTranslation {}

class PartnerBillsListPage extends React.Component<PartnerBillsListProps> {
    //========================================//
    //=============== Builders ===============//
    //========================================//

    generateStatusOptions = (): PickerOption[] => {
        return generateOptionsString(
            this.props.t,
            ['pending', 'blocked', 'validated', 'reported', 'sent'],
            'partner_bill_status.',
        );
    };

    headerBuilder = (): HeadCell[] => {
        const { t } = this.props;
        const headers: HeadCell[] = [
            createCell(t, Cell.BILL_NUMBER),
            createCell(t, Cell.BILL_DOCUMENT_PATH),
            createCell(t, Cell.PARTNER_ID),
            createCell(t, Cell.AMOUNT_WITH_TAX, { label: t('amount_due'), filterable: false }),
            createCell(t, Cell.STATUS, { pickerOptions: this.generateStatusOptions() }),
            createCell(t, Cell.PERIOD),
        ];
        return headers;
    };

    render() {
        const { t } = this.props;

        return (
            <App
                needRights={AccountRight.PARTNER_BILLING_MGMT}
                disableBreadcrumb
                header={{
                    title: t('all.title'),
                }}
            >
                <EnhancedTable headers={this.headerBuilder()} type={tableRequestPoints.PARTNER_BILLS_BETA} />
            </App>
        );
    }
}

export default withTranslation(['partner_bill', 'common'])(PartnerBillsListPage);
